import { isWithinInterval } from 'date-fns';

import { getTimeInTeamTimezone } from '../../pages/YourTeams/utils/timelineUtils';

import { HighlightPeriod } from './types';

// Extracted helper function to create period modifiers
export const createPeriodModifiers = (
  period: HighlightPeriod,
  prefix: string,
): { [key: string]: (date: Date) => boolean } => {
  const mods: { [key: string]: (date: Date) => boolean } = {};

  mods[prefix] = (date: Date) =>
    isWithinInterval(date, {
      start: period.start,
      end: period.end,
    });

  mods[`${prefix}_start`] = (date: Date) => {
    if (date.getTime() === period.start.getTime()) return true;
    // Check if it's first day of month within period
    return (
      date.getDate() === 1 &&
      isWithinInterval(date, {
        start: period.start,
        end: period.end,
      })
    );
  };

  mods[`${prefix}_end`] = (date: Date) => {
    if (date.getTime() === period.end.getTime()) return true;
    // Check if it's last day of month within period
    const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return (
      date.getDate() === lastDayOfMonth.getDate() &&
      isWithinInterval(date, {
        start: period.start,
        end: period.end,
      })
    );
  };

  return mods;
};

// Helper to safely convert dates to team timezone
export const toTeamTimezone = (date?: Date): Date | undefined => {
  return date ? getTimeInTeamTimezone(date) : undefined;
};
